import {CheckboxField, checkbox, comp, Component, fieldset, h3, Notifier, p, router} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ServerApi} from "./util/ServerApi.js";

export class UnsubscribeReminders extends Component {
	constructor(participantId: string) {
		super("section");

		this.itemId = "unsubscribe-reminders";
		this.id = "unsubsncribe-reminders";
		this.cls = "ifw-card";

		ServerApi.single("elearning/frontend/participants/", participantId, CurrentParticipant.returnProperties)
			.then(async (participantData) => {
				if(!participantData.success) {
					Notifier.warning(t(participantData.message),5000);
					await router.goto("");
				}
				sessionStorage.setItem(CurrentParticipant.storageItem, JSON.stringify(participantData.data));
				const cp = CurrentParticipant.get();
				const f = fieldset({},
					comp({cls: "ifw-title-cnt"},
						h3({cls: "ifw-title", text: t("Reminder settings")})
					),
					comp({cls: "vbox"},
						p({html: `${t("Welcome")} ${cp.fullName}`}),
						p({html: t("You can select if you want to receive reminders about courses that expire.")})
					),
					checkbox({
						label: t("Reminders"),
						name: "remindMe",
						type: "switch",
						value: cp.remindMe,
						listeners: {
							change: (_field: CheckboxField, newValue: any, _oldValue: any) => {
								let route = "elearning/frontend/participants/" + cp.id,
									body = {
										remindMe: newValue
									};
								ServerApi.call(route, body, "PUT").then(async (result) => {
									await CurrentParticipant.refresh(result);
									Notifier.success(t("Saved successfully"), 5000);
								});
							}
						}
					}),
				);
				this.items.add(f);
			});
	}

}